
export default function Footer() {
  return (
    <footer className="bg-[#0A2463] text-white py-8">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col items-center text-center gap-4">
          <img 
            src="https://public.readdy.ai/ai/img_res/e57aec86-0c9d-4019-b453-4adb6da4b885.png" 
            alt="Logo" 
            className="w-16 h-16 object-contain"
          />
          <p className="text-gray-300 text-sm leading-relaxed max-w-md">
            Transformando a relação entre tutores e seus cães através de técnicas comprovadas de adestramento positivo e institívo
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 text-sm">
            <a href="mailto:jokadogadestramento@gmail.com" className="flex items-center gap-2 text-gray-300 hover:text-[#FFB800] transition-colors duration-200 cursor-pointer">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line text-[#FFB800]"></i>
              </span>
              jokadogadestramento@gmail.com
            </a>
            <span className="hidden sm:block text-gray-600">|</span>
            <a href="https://wa.me/5511942623635" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-300 hover:text-[#FFB800] transition-colors duration-200 cursor-pointer">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-whatsapp-line text-[#FFB800]"></i>
              </span>
              (11) 94262-3635
            </a>
          </div>

          <div className="flex gap-3 mt-1">
            <a 
              href="#" 
              className="w-9 h-9 bg-[#FFB800] rounded-full flex items-center justify-center hover:bg-[#FFA500] transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-facebook-fill text-[#0A2463] text-lg"></i>
            </a>
            <a 
              href="https://www.instagram.com/_jokadog?igsh=MW11eWxjdGNyNDZtZA==" 
              target="_blank"
              rel="noopener noreferrer"
              className="w-9 h-9 bg-[#FFB800] rounded-full flex items-center justify-center hover:bg-[#FFA500] transition-colors duration-200 cursor-pointer"
            >
              <i className="ri-instagram-line text-[#0A2463] text-lg"></i>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-6 pt-4 text-center">
          <p className="text-gray-400 text-xs">
            © 2025 Adestramento Canino. Todos os direitos reservados. | <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-[#FFB800] hover:underline cursor-pointer">Powered by Readdy</a>
          </p>
        </div>
      </div>
    </footer>
  );
}
